export const HEADER_IMAGES_URLS = [
  'https://img-cdn.financeunlocked.com/headers-images/1.jpg',
  'https://img-cdn.financeunlocked.com/headers-images/2.jpg',
  'https://img-cdn.financeunlocked.com/headers-images/3.jpg',
  'https://img-cdn.financeunlocked.com/headers-images/4.jpg',
];

export const VIDEO_MAX_PROGRESS = 90;
export const VIDEO_MIN_PROGRESS = 10;

export const SECONDS_IN_HOUR = 3600;
export const SECONdS_IN_MINUTE = 60;

export const SUSTAINABILITY_REFERENT = 'sustainabilityunlocked';

export const WIDE_CATEGORY_LABEL_WIDTH = 160;

export const CURRENCY_CODE_TO_SYMBOL = {
  usd: '$',
  eur: '€',
  gbp: '£',
};

export const COURSE_PAGE_CUSTOM_BLOCKS_URL = '/courses/';
